import React from "react";
import "./Hero.scss";
import background from "../../assets/hero-desktop.png";
import circle from "../../assets/circle-desktop.svg";
import logo from "../../assets/logo.png";
import globe from "../../assets/globe-desktop.svg";
import recs from "../../assets/recs-desktop.png";

function Hero() {
  return (
    <section className="hero">
      <img src={background} className="hero__background" alt="" />
      <img src={circle} className="hero__circle" alt="" />
      <div className="hero__content">
        <img src={logo} className="hero__logo" alt="" />
        <h1 className="hero__title">
          How 5G and Edge Computing Enable Digital Transformation
        </h1>
        <img src={globe} className="hero__globe" alt="" />
      </div>
      <div className="hero__recs__container">
        <img src={recs} className="hero__recs" alt="" />
      </div>
    </section>
  );
}

export default Hero;
